var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tabs",
    { attrs: { pills: "", card: "", vertical: "" } },
    [
      _vm._l(_vm.rest.sections, function (section, sidx) {
        return _c(
          "b-tab",
          {
            key: sidx,
            attrs: { active: section.is_active },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "fs-lg px-4 text-center d-flex justify-content-between align-items-center",
                        },
                        [
                          _c("span", { staticClass: "flex-grow-1" }, [
                            _vm._v(_vm._s(section.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-danger ml-2",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.removeSection(sidx)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-trash-alt" })]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          [
            _vm._v(" "),
            _c("table-list", {
              attrs: { section_id: section.id },
              model: {
                value: section.tables,
                callback: function ($$v) {
                  _vm.$set(section, "tables", $$v)
                },
                expression: "section.tables",
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "b-tab",
        {
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "fs-lg px-4 text-center" }, [
                    _vm._v(_vm._s(_vm.__t("ADD_SECTION"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-4", staticStyle: { "max-width": "360px" } },
            [
              _c("h5", { staticClass: "frame-heading mb-3" }, [
                _vm._v(_vm._s(_vm.__t("ADD_SECTION"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "new_section_name" },
                    },
                    [_vm._v(_vm._s(_vm.__t("NAME")))]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "form-control form-control-use",
                    attrs: {
                      id: "new_section_name",
                      placeholder: _vm.__t("NAME"),
                    },
                    model: {
                      value: _vm.new_section.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_section, "name", $$v)
                      },
                      expression: "new_section.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "new_section_uniq_id" },
                    },
                    [_vm._v(_vm._s(_vm.__t("UNIQ_ID_CAN_BE_EMPTY")))]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "form-control form-control-use",
                    attrs: {
                      id: "new_section_uniq_id",
                      placeholder: _vm.__t("UNIQ_ID_CAN_BE_EMPTY"),
                    },
                    model: {
                      value: _vm.new_section.uniq_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_section, "uniq_id", $$v)
                      },
                      expression: "new_section.uniq_id",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary waves-effect waves-themed",
                  attrs: { disabled: !_vm.new_section.name },
                  on: { click: _vm.addSection },
                },
                [
                  _c("i", { staticClass: "fal fa-plus mr-2" }),
                  _vm._v(_vm._s(_vm.__t("ADD_SECTION")) + "\n            "),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }